import { IProposalQtyCount, ProposalInterfaces } from "../interfaces";
import BaseApi from "./BaseApi";

const baseUrl = 'api/dashboard/';

class DashboardService {

    static async getSalesCount(): Promise<any> {
        return BaseApi.get(`${baseUrl}sales/count`);
    }

    static async getSalesTotalMonth(): Promise<any> {
        return BaseApi.get(`${baseUrl}sales/month/total`);
    }

    static async getEarningPotential(): Promise<any> {
        return BaseApi.get(`${baseUrl}sales/EarningPotential/0`);
    }

    static async getPipelineCount(): Promise<any> {
        return BaseApi.get(`${baseUrl}pipeline/count`);
    }

    static async getPipelineMonthCount(date?: Date): Promise<IProposalQtyCount[]> {
        return BaseApi.get(`${baseUrl}pipeline/count/month`, {
            params: {
                date: date?.toISOString()
            }
        });
    }
    static getProposalSumByType(id: number): Promise<ProposalInterfaces.IGetStatusProposalStatusByType> {
        return BaseApi.get(`${baseUrl}proposalSumByType/${id}`);
    }
}

export default DashboardService;